import {
  ProfessionalNotificationUpdateDto,
  ProfessionalNotificationsListResponse,
} from '@docbay/schemas';
import {
  UpdateNotificationParamsDto,
  GetNotificationsParamsDto,
} from 'common/types/notifications';
import axiosInstance from 'integration/api/axiosInstance';

/**
 * API methods for notifications.
 */
export const NotificationsAPI = {
  /**
   * Gets a list of professional notifications.
   *
   * @param params - Parameters to filter the notifications by.
   * @returns A promise that resolves with the response containing
   *   the list of notifications.
   */
  getNotifications: ({ page, limit, search }: GetNotificationsParamsDto) => {
    const params = {
      includeDeleted: 'false',
      ...(page ? { page } : {}),
      ...(limit ? { limit } : {}),
      ...(search ? { search } : {}),
    };
    return axiosInstance.get<ProfessionalNotificationsListResponse>(
      '/professional-notifications',
      { params },
    );
  },

  /**
   * Updates a professional notification.
   *
   * @param params - Parameters containing the notification ID
   *   and whether it is read or not.
   * @returns A promise that resolves with the response containing
   *   the updated notification.
   */
  updateNotification: ({ id, isRead }: UpdateNotificationParamsDto) =>
    axiosInstance.patch<ProfessionalNotificationUpdateDto>(
      `/professional-notifications/${id}`,
      { isRead },
    ),

  /**
   * Marks all professional notifications as read.
   *
   * @returns A promise that resolves with the response.
   */
  readAllNotification: () =>
    axiosInstance.patch('/professional-notifications/mark-all-as-read'),
};
